import { render } from "./TvmSlideOutServiceSpecial.vue?vue&type=template&id=098e7fc4&scoped=true"
import script from "./TvmSlideOutServiceSpecial.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutServiceSpecial.vue?vue&type=script&lang=js"

import "./TvmSlideOutServiceSpecial.vue?vue&type=style&index=0&id=098e7fc4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098e7fc4"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmSlideOutServiceSpecial/TvmSlideOutServiceSpecial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "098e7fc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('098e7fc4', __exports__)) {
    api.reload('098e7fc4', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutServiceSpecial.vue?vue&type=template&id=098e7fc4&scoped=true", () => {
    api.rerender('098e7fc4', render)
  })

}


export default __exports__